module.exports = __webpack_public_path__ + "img/patient_list.639224f6.svg";